import { useEffect, useMemo } from 'react';
import useCodelists from 'hooks/useCodelists';
import { DeclarationCountry } from 'store/declarations/enums/common/declaration-country';
import { DeclarationTypes } from 'store/declarations/enums/common/declaration-types';
import getConditionCodeOptions from '../utils/getConditionCodeOptions';

const useCommodityConditionCodelists = () => {
    const { aisCodelists, getCodeLists, checkLoading } = useCodelists();

    useEffect(() => {
        getCodeLists(DeclarationCountry.IRELAND, DeclarationTypes.AIS, undefined);
    }, [getCodeLists]);

    const countryOptions = aisCodelists?.countryCodesFullList;
    const conditionCodeOptions = useMemo(
        () => getConditionCodeOptions(aisCodelists?.commonDocumentsType),
        [aisCodelists?.commonDocumentsType]
    );
    const isLoading = checkLoading(DeclarationCountry.IRELAND);

    return { countryOptions, conditionCodeOptions, isLoading };
};

export default useCommodityConditionCodelists;
